import { useStytchSession } from "@stytch/react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { session, isInitialized } = useStytchSession();

  // while the SDK is loading stored session, you can return null or a loader
  // if (!isInitialized) {
  //   return ;
  // }

  // no valid session → send back to login
  if (!session) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// const ProtectedRoute = ({ children }) => {
//   // Grab the member info & status from Stytch B2B

//   const { member } = useStytchMember();

//   // If no member is logged in, redirect to login
//   if (!member) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// };

export default ProtectedRoute;
